import React, { useState } from "react";
import DashboardContainer from "@/components/layout/DashboardContainer";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import EmployerList from "./EmployerList";
import IssuesList from "./IssuesList";
import AffiliatePartnersList from "./AffiliatePartnersList";
import { ImplementationEmployersList } from './ImplementationEmployersList';
import ContractorEntitiesList from "./ContractorEntitiesList";
import TaskStatusMonitor from "./TaskStatusMonitor";
import TerminationApprovals from "./TerminationApprovals";
import DemoAccountsList from "./DemoAccountsList";

const OperationsDashboard: React.FC = () => {
  const [activeTab, setActiveTab] = useState<string>("employers");

  return (
    <DashboardContainer
      title="Operations Dashboard"
      headerContent={
        <div className="text-sm text-gray-500">
          Monitor and manage payroll processing, background tasks, and operational issues across all customers
        </div>
      }
    >
      <Tabs
        defaultValue="employers"
        value={activeTab}
        onValueChange={setActiveTab}
        className="w-full"
      >
        <TabsList className="mb-6">
          <TabsTrigger value="employers">Employers</TabsTrigger>
          <TabsTrigger value="issues">Issues</TabsTrigger>
          <TabsTrigger value="terminations">Termination Approvals</TabsTrigger>
          <TabsTrigger value="tasks">Task Status</TabsTrigger>
          <TabsTrigger value="contractors">Contractor Entities</TabsTrigger>
          <TabsTrigger value="demo">Demo Accounts</TabsTrigger>
        </TabsList>

        <TabsContent value="employers" className="space-y-6">
          <EmployerList />
          <div className="mt-8">
            <ImplementationEmployersList />
          </div>
          <div className="mt-8">
            <AffiliatePartnersList />
          </div>
        </TabsContent>

        <TabsContent value="issues" className="space-y-6">
          <IssuesList />
        </TabsContent>

        <TabsContent value="terminations" className="space-y-6">
          <TerminationApprovals />
        </TabsContent>

        <TabsContent value="tasks" className="space-y-6">
          <TaskStatusMonitor />
        </TabsContent>

        <TabsContent value="contractors" className="space-y-6">
          <ContractorEntitiesList />
        </TabsContent>

        <TabsContent value="demo" className="space-y-6">
          <DemoAccountsList />
        </TabsContent>
      </Tabs>
    </DashboardContainer>
  );
};

export default OperationsDashboard; 